import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimType.SoftDelete.IRequest;
type Response = Api.Core.ClaimType.SoftDelete.IResponse;
type Headers = Api.Core.ClaimType.SoftDelete.IHeaders;
const url = '/api/Claims/ClaimType/SoftDelete/:id';
export default async function claimTypeSoftDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
